var map = {
	"./ACGIH-Heavy": 438,
	"./ACGIH-Heavy.json": 438,
	"./ACGIH-Light": 439,
	"./ACGIH-Light.json": 439,
	"./ACGIH-Moderate": 440,
	"./ACGIH-Moderate.json": 440,
	"./ACSM-Acclimatized": 441,
	"./ACSM-Acclimatized.json": 441,
	"./ACSM-NonAcclimatized": 442,
	"./ACSM-NonAcclimatized.json": 442,
	"./GaStateHighSchool": 443,
	"./GaStateHighSchool.json": 443,
	"./KyStateHighSchool": 444,
	"./KyStateHighSchool.json": 444,
	"./NATA": 445,
	"./NATA.json": 445,
	"./NcStateHighSchool": 446,
	"./NcStateHighSchool.json": 446,
	"./NjStateHighSchool": 447,
	"./NjStateHighSchool.json": 447,
	"./TBMed507-Easy": 448,
	"./TBMed507-Easy.json": 448,
	"./TBMed507-Hard": 449,
	"./TBMed507-Hard.json": 449,
	"./TBMed507-Moderate": 450,
	"./TBMed507-Moderate.json": 450,
	"./UsaSoccer-Cat1": 451,
	"./UsaSoccer-Cat1.json": 451,
	"./UsaSoccer-Cat2": 452,
	"./UsaSoccer-Cat2.json": 452,
	"./UsaSoccer-Cat3": 453,
	"./UsaSoccer-Cat3.json": 453,
	"./VtStateHighSchool": 454,
	"./VtStateHighSchool.json": 454,
	"./_HeatStressGuidelinesIndex": 352,
	"./_HeatStressGuidelinesIndex.json": 352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 674;